import "../DownloadNew/DownloadNew.css";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Pagination } from "antd";

import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { format, parseISO } from "date-fns";
import Download_share from "../../../images/downlodes_share.webp";
import DownloadBanner from "../DownloadBanner/DownloadBanner";
import { useParams } from "react-router-dom";
import animation from "../../../images/jm-animation.gif";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { trackEvent, trackPageView } from "../../utils/tracking";

// NEW: 404 fallback rendered when the /downloads/... URL doesn't
// correspond to a real category / sub-category.
import NotFound from "../../NotFound/NotFound";

// Replaces VALID_CATEGORY_SLUGS — single source of truth for slug -> {name, catId}
const CATEGORY_SLUG_MAP = {
  "scheme-financials": { name: "Scheme Financials", catId: "1" },
  "portfolio-disclosure": { name: "Portfolio Disclosure", catId: "2" },
  "statutory-disclosure": { name: "Statutory Disclosure", catId: "3" },
  "other-disclosure": { name: "Other disclosure", catId: "4" },
  "scheme-related-documents": { name: "Scheme related documents", catId: "5" },
  "notice-and-addendums": { name: "Notice and Addendums", catId: "6" },
  "factsheet": { name: "Factsheet", catId: "10" },
  "nfo": { name: "NFO", catId: "20" },
  "forms": { name: "Forms", catId: "7" },
  "product-literature": { name: "Product Literature", catId: "14" },
  "portfolio": { name: "Portfolio", catId: "8" },
  "others": { name: "Others", catId: "9" },
  "investor-awareness-program": { name: "Investor Awareness Program", catId: "18" },
};

const normalize = (s) => (s || "").toString().toLowerCase().replace(/[\s-]/g, "");

function DownloadNew() {
  const { CategeryId } = useParams();
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [dataDrop, setDataDrop] = useState([]);
  const [datadropsub, setDataDropsub] = useState([]);
  const [value, setValue] = React.useState(5);
  const [catId, setCatId] = useState("0");
  const [schemeDownload, setSchemeDownload] = useState("");
  const [SearchData, setSearchData] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [subcatId, setSubCatId] = useState("37");
  const socialIconsRef = useRef(null);
  const searchWrapperRef = useRef(null); // NEW: wraps input + results dropdown, for click-outside collapse
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setselectedYear] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");
  const [currentPopupId, setCurrentPopupId] = useState("");
  const [CategoryIdUrl, SetCategoryIdUrl] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingshow, setLoadingshow] = useState(false);
  const [pathname, setPathName] = useState("");
  const [current, setCurrent] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [size, setSize] = useState(perPage);

  // NEW: drives the 404 fallback.
  const [notFound, setNotFound] = useState(false);

  let categoryIdNew,
    subCategoryIdNew,
    categoryNameNew,
    subCategoryNameNew,
    dataNew;
  const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
    useContext(URLstateContext);
  const navigate = useNavigate();

  useEffect(() => {
    const segments = window.location.pathname
      .split("/")
      .filter((segment) => segment.trim() !== "");

    if (segments.length === 1) {
      // Plain "/downloads" — the default landing view, not an error.
      setNotFound(false);
      return;
    }

    if (segments.length === 2) {
      // /downloads/:category
      const slug = segments[1].toLowerCase();
      setPathName(segments[1]);

      const match = CATEGORY_SLUG_MAP[slug];
      if (!match) {
        setNotFound(true);
        return;
      }

      setNotFound(false);
      SetCategoryIdUrl(match.name);
      setCatId(match.catId);
      setSubCatId("0");
      return;
    }

    if (segments.length === 3) {
      // /downloads/:category/:subcategory
      const CategoryName = decodeURIComponent(segments[1]).replace(/-/g, " ");
      let SubCategoryName = decodeURIComponent(segments[2]);

      SubCategoryName =
        segments[1].toLowerCase() === "forms"
          ? SubCategoryName.replace(/-Forms$/i, " Forms")
          : SubCategoryName.replace(/-/g, " ");

      GetPostMethodData(BaseURL + "GetDownloadNewSub", {
        IVSubCategoryName: SubCategoryName,
      })
        .then((res) => {
          const decrypted = res.data?.length ? DecryptAESdata(res.data) : [];
          const row = decrypted[0];

          const isRealMatch =
            row?.DownloadCategoryID &&
            row?.DownloadSubCategoryID &&
            normalize(row.SubCategoryName) === normalize(SubCategoryName);

          if (!isRealMatch) {
            setNotFound(true);
            return;
          }

          setNotFound(false);
          SetCategoryIdUrl(CategoryName);
          setSchemeDownload(SubCategoryName);
          setCatId(row.DownloadCategoryID);
          setSubCatId(row.DownloadSubCategoryID);
        })
        .catch(() => setNotFound(true));
      return;
    }

    // 0 segments (shouldn't happen under /downloads/*) or 4+ segments
    setNotFound(true);
  }, [BaseURL]);

  function extractDomainFromURL(url) {
    var parser = document.createElement("a");
    parser.href = url;
    return (
      parser.protocol +
      "//" +
      parser.hostname +
      (parser.port ? ":" + parser.port : "")
    );
  }

  const handleChangeCat = (event) => {
    setCurrent(1);
    setSelectedMonth("");
    setselectedYear("");
    setSelectedFileType("");
    event.preventDefault();
    setSubCatId("0");
    setCatId(event.target.value);
    navigate(
      `/downloads/${event.target.options[event.target.selectedIndex].text
        .replace(/ /g, "-")
        .replace("&", "and")
        .replace("+", "")}`
    );
  };

  const handleChangeSubCat = (event) => {
    setCurrent(1);
    setSubCatId(event.target.value);
    setselectedYear("");

    const selectDiv = document.getElementById("category-select");
    const schemeDescSub = document.getElementById("subcategory-select");

    const catIdNew = selectDiv.options[selectDiv.selectedIndex].text;
    let subCatNew = schemeDescSub.options[schemeDescSub.selectedIndex].text;

    SetCategoryIdUrl(catIdNew);
    setSchemeDownload(subCatNew);

    subCatNew = subCatNew.replace(/\//g, "");

    const encodedCatId = encodeURIComponent(catIdNew)
      .replace(/%20/g, "-")
      .replace(/%26/g, "and");

    const encodedSubCat = encodeURIComponent(subCatNew)
      .replace(/%20/g, "-")
      .replace(/%26/g, "and");

    const updatedURL = `/downloads/${encodedCatId}/${encodedSubCat}`;

    navigate(updatedURL);
  };

  // Category-browse table only — this loads the documents for whatever
  // category/sub-category is currently selected. It is intentionally
  // NOT tied to SearchText anymore: typing in the search box should not
  // re-scope this list, and this list being scoped should not limit
  // what the search box can find (that was the root cause of the bug
  // where searching only worked within whatever tab was selected).
  useEffect(() => {
    document.getElementById("searchtext").style.display = "none";
    document.getElementById("SearchData").style.display = "none";
    if (catId === "7") {
      document.getElementById("yearsdrop").style.display = "none";
      document.getElementById("yearsdroplab").style.display = "none";
    } else {
      document.getElementById("yearsdrop").style.display = "block";
      document.getElementById("yearsdroplab").style.display = "block";
    }
    setLoadingshow(true);

    if (catId !== "") {
      GetPostMethodData(BaseURL + "GetDownloadNew", {
        IICategoryID: catId,
        IISubCategoryID: subcatId,
        IVsearch: "",
      }).then((data) => {
        setLoadingshow(false);
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
        } else {
          setData([]);
        }
      });
    }
  }, [BaseURL, catId, subcatId]);

  // NEW: global search — always searches across every category / sub
  // category (IICategoryID / IISubCategoryID sent as "0"), regardless
  // of what's currently selected in the dropdowns. This is what makes
  // "Product Literature" etc. findable even while "Factsheet" (or any
  // other tab) is selected.
  useEffect(() => {
    if (SearchText !== "" && SearchText.length >= 3) {
      GetPostMethodData(BaseURL + "GetDownloadNew", {
        IICategoryID: "0",
        IISubCategoryID: "0",
        IVsearch: SearchText,
      }).then((data) => {
        if (data.data != null && data.data.length > 0) {
          setSearchData(DecryptAESdata(data.data));
          setJsonData(DecryptAESdata(data.data));
        } else {
          setSearchData(null);
        }
        document.getElementById("searchtext").style.display = "block";
        document.getElementById("SearchData").style.display = "block";
      });
    } else {
      document.getElementById("searchtext").style.display = "none";
      document.getElementById("SearchData").style.display = "none";
    }
  }, [BaseURL, SearchText]);

  // NEW: collapse the search results dropdown when the user clicks
  // anywhere outside the search box (input + results list).
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchWrapperRef.current &&
        !searchWrapperRef.current.contains(event.target)
      ) {
        document.getElementById("searchtext").style.display = "none";
        document.getElementById("SearchData").style.display = "none";
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!catId || catId === "0") {
      if (SearchText === "") {
        document.getElementById("searchtext").style.display = "none";
        document.getElementById("SearchData").style.display = "none";
      }
    }
    GetPostMethodData(BaseURL + "GetDownloadDrop", {
      IICategoryID: "0",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDrop(DecryptAESdata(data.data));
      }
    });
    GetPostMethodData(BaseURL + "GetDownloadDrop", {
      IICategoryID: catId,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropsub(DecryptAESdata(data.data));
      }
    });
  }, [BaseURL, catId]);

  const handleShareButtonClick = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    const popupId = "d_" + fetchId.split("_")[1];
    const popup = document.getElementById(popupId);
    const isSamePopup = currentPopupId === popupId;

    if (currentPopupId) {
      const currentPopup = document.getElementById(currentPopupId);
      if (currentPopup) {
        currentPopup.style.display = isSamePopup ? "none" : "none";
      }
    }

    if (!isSamePopup) {
      popup.style.display = "block";
      setCurrentPopupId(popupId);
    } else {
      setCurrentPopupId(null);
    }

    setIsLinkCopied(false);
  };

  const handleEmailClick = (e) => {
    const blgURL = e.currentTarget.getAttribute("data-head");
    const subject = "Check out this amazing website!";
    const body =
      "Hi,\n\nI found this awesome website that I think you'll love! Check it out:" +
      `${blgURL}`;
    const recipientInput = window.prompt(
      "Enter recipient email addresses (comma-separated):"
    );

    if (recipientInput) {
      const recipients = recipientInput.split(",").map((email) => email.trim());
      const to = recipients.join(",");
      const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoURL;
    }
  };

  const downloadPDF = async (e) => {
    const BaseURL1 = e.currentTarget.getAttribute("data-head");
    const BaseURL = BaseURL1;
    const fileName = BaseURL.split("/").pop();
    try {
      const response = await fetch(BaseURL);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const tempAnchor = document.createElement("a");
      tempAnchor.href = url;
      tempAnchor.download = fileName;
      document.body.appendChild(tempAnchor);
      tempAnchor.click();
      document.body.removeChild(tempAnchor);
      URL.revokeObjectURL(url);
    } catch (error) {}
  };

  const downloadPDFDrop = async (e) => {
    const BaseURL1 = e.currentTarget.getAttribute("data-head");
    const BaseURL = BaseURL1;
    const fileName = BaseURL1.split("/")[3];
    try {
      const response = await fetch(BaseURL);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const tempAnchor = document.createElement("a");
      tempAnchor.href = url;
      tempAnchor.download = fileName;
      document.body.appendChild(tempAnchor);
      tempAnchor.click();
      document.body.removeChild(tempAnchor);
      URL.revokeObjectURL(url);
      document.getElementById("searchtext").style.display = "none";
      document.getElementById("SearchData").style.display = "none";
    } catch (error) {}
  };

  const handleCopyClick = (e) => {
    const blgURL = e.currentTarget.getAttribute("data-head");
    const linkToCopy = blgURL;
    const inputElement = document.createElement("input");
    inputElement.value = linkToCopy;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand("copy");
    document.body.removeChild(inputElement);
    setIsLinkCopied(true);
  };

  let DataFilter = [];

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  function getDistinctYears(data) {
    const distinctYearsSet = new Set(
      data.map((item) => new Date(item.DocumentDate).getFullYear())
    );
    let yearsFinal = Array.from(distinctYearsSet);
    let startYear = yearsFinal[0];

    if (startYear !== undefined) {
      yearsFinal.unshift(startYear + 1);
      return yearsFinal;
    }

    return yearsFinal;
  }

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    setCurrent(1);
  };
  const handleYearChange = (event) => {
    setselectedYear(event.target.value);
    setCurrent(1);
  };

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
    setCurrent(1);
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    if (currentMonth < 3) {
      return `${currentYear - 1} - ${currentYear}`;
    } else {
      return `${currentYear} - ${currentYear + 1}`;
    }
  };

  const filterData = (data, selectedMonth, selectedYear, selectedFileType) => {
    return (
      data &&
      data.filter((item) => {
        const documentDate = new Date(item.DocumentDate);
        if (selectedYear === "") {
          return selectedFileType === "" || item.FileEXT === selectedFileType;
        }
        const selectedYearValue = parseInt(selectedYear, 10);
        const fileTypeCondition =
          selectedFileType === "" || item.FileEXT === selectedFileType;
        const otherFiscalYearStart = new Date(selectedYearValue - 1, 3, 1);
        const otherFiscalYearEnd = new Date(selectedYearValue, 2, 31);
        const isDataInOtherYear =
          documentDate >= otherFiscalYearStart &&
          documentDate <= otherFiscalYearEnd;
        return isDataInOtherYear && fileTypeCondition;
      })
    );
  };

  function isDataInPreviousYear(selectedYearValue, documentDate) {
    const year1Start = new Date(selectedYearValue - 1, 3, 1);
    const year1End = new Date(selectedYearValue, 2, 31);
    return documentDate >= year1Start && documentDate <= year1End;
  }

  const filteredData = useMemo(() => {
    return filterData(data, selectedMonth, selectedYear, selectedFileType);
  }, [data, selectedMonth, selectedYear, selectedFileType]);

  function handleInputChange(event) {
    document.getElementById("searchtext").style.display = "block";
    let Blogdata = event.target.value;
    if (Blogdata.length >= 3) {
      setSearchText(Blogdata);
    } else {
      DataFilter = [];
      setSearchText("");
      setSearchData(DataFilter);

      if (SearchData === "") {
        document.getElementById("searchtext").style.display = "none";
      }
    }
  }

  let schemeDesc = document.getElementById("category-select");
  let schemeDescSub = document.getElementById("subcategory-select");

  let PageSize = size;

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const currentTableData = useMemo(() => {
    if (filteredData != null && filteredData.length > 0) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return filteredData.slice(firstPageIndex, lastPageIndex);
    }
    return [];
  }, [current, PageSize, filteredData, SearchData]);

  const itemRender = (page, type, originalElement) => {
    switch (type) {
      case "prev":
        return (
          <button
            type="button"
            className="pagination-arrow"
            aria-label="Go to previous page"
          >
            <i className="fa fa-angle-double-left" aria-hidden="true"></i>
          </button>
        );

      case "next":
        return (
          <button
            type="button"
            className="pagination-arrow"
            aria-label="Go to next page"
          >
            <i className="fa fa-angle-double-right" aria-hidden="true"></i>
          </button>
        );

      default:
        return originalElement;
    }
  };

  // NEW: bail out to the 404 page before rendering any of the normal
  // downloads UI. This runs after all hooks above, so hook order is
  // unaffected.
  if (notFound) {
    return <NotFound />;
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Download the latest monthly factsheets for JM Financial Mutual Fund schemes. Stay informed about NAVs, portfolio details, and performance metrics for better decision-making."
          />
          <title>
            Monthly Factsheet Download | Access Latest Fund Performance Data |
            JM Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

      <DownloadBanner />
      <main
        className="downlodes-main"
        style={{ fontSize: `${fontSize}px` }}
        id="main-content"
        tabIndex="-1"
      >
        <section className="downlodes_banner-sc">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="form-group-container">
                  <div className="form-group search-input" ref={searchWrapperRef}>
                    <input
                      type="text"
                      name="SearchBlogs"
                      onChange={handleInputChange}
                      id="SearchBlogs"
                      aria-label="Search downloads"
                      placeholder="What Are You Looking To Download..."
                      autoComplete="off"
                    />
                    <div className="icon-container" id="searchtext">
                      <div className="downloades_input-search-container">
                        <div
                          role="status"
                          aria-live="polite"
                          aria-atomic="true"
                          className="sr-only"
                        >
                          {SearchData?.length === 0
                            ? "No data found"
                            : `${SearchData?.length || 0} results found`}
                        </div>
                        {SearchData && SearchData.length > 0 ? (
                          <>
                            <div
                              className="downloades_input-search"
                              id="SearchData"
                            >
                              <ul>
                                <li className="font-bold-category">Category</li>
                                <li className="font-bold-category">
                                  Sub Category
                                </li>
                                <li className="font-bold-category">Title</li>
                              </ul>
                              {SearchData &&
                                SearchData.map(
                                  ({
                                    CategoryName,
                                    FileName,
                                    SubCategoryName,
                                    Title,
                                  }) => (
                                    <ul className="search-ul">
                                      <li>
                                        <a>{CategoryName}</a>
                                      </li>
                                      <li>
                                        <a>{SubCategoryName}</a>
                                      </li>
                                      <li>
                                        <a
                                          data-head={FileName}
                                          onClick={downloadPDFDrop}
                                        >
                                          {Title}
                                        </a>
                                      </li>
                                    </ul>
                                  ),
                                )}
                            </div>
                          </>
                        ) : (
                          <div
                            className="downloades_input-search no_data_search"
                            id="SearchData"
                          >
                            <p>No Data Found !!!</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <div className="selects-containers">
                      <div className="select-container">
                        <label htmlFor="category-select" className="sr-only">
                          Select category
                        </label>
                        <select
                          name="fund"
                          id="category-select"
                          className="fund-selector"
                          onChange={handleChangeCat}
                          autoComplete="off"
                        >
                          <option value="0">Select Category</option>
                          {dataDrop &&
                            dataDrop.map(
                              ({ DownloadCategoryID, CategoryName }) => (
                                <option
                                  value={DownloadCategoryID}
                                  selected={CategoryIdUrl === CategoryName}
                                >
                                  {CategoryName}
                                </option>
                              ),
                            )}
                        </select>
                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                      <div className="select-container">
                        <label htmlFor="subcategory-select" className="sr-only">
                          Select sub category
                        </label>
                        {catId === "0" ? (
                          <select
                            name="fund"
                            id="subcategory-select"
                            className="fund-selector"
                            autoComplete="off"
                            disabled
                          >
                            <option value="">Select Sub Category</option>
                          </select>
                        ) : (
                          <select
                            name="fund"
                            id="subcategory-select"
                            className="fund-selector"
                            onChange={handleChangeSubCat}
                            autoComplete="off"
                          >
                            <option value="0">Select Sub Category</option>
                            {datadropsub &&
                              datadropsub.map(
                                ({
                                  DownloadSubCategoryID,
                                  SubCategoryName,
                                }) => (
                                  <option
                                    value={DownloadSubCategoryID}
                                    selected={
                                      schemeDownload === SubCategoryName
                                    }
                                  >
                                    {SubCategoryName}
                                  </option>
                                ),
                              )}
                          </select>
                        )}
                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div></div>
        </section>

        <section className="downlodes_application-form-sc">
          <Container>
            <Row>
              <Col>
                <nav aria-label="Breadcrumb">
                  <ul className="navigator-arrow">
                    <li>
                      <a href="/" aria-label="Home">
                        <i class="fa fa-home" aria-hidden="true"></i>
                      </a>{" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </li>
                    <li>
                      <a href="/downloads">
                        <span>Downloads</span>
                      </a>{" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </li>
                    <li>
                      {schemeDesc != null && schemeDesc != undefined
                        ? schemeDesc.options[schemeDesc.selectedIndex].text !=
                          "Select Category"
                          ? schemeDesc.options[schemeDesc.selectedIndex].text
                          : ""
                        : ""}
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </Container>

          <Container>
            <Row>
              <Col sm={12}>
                <div className="downlode-container">
                  <div className="select-bar">
                    <p className="fin-year p-1 p-md-0 fs-6" id="yearsdroplab">
                      FY{" "}
                    </p>
                    <div className="select-container" id="yearsdrop">
                      <label
                        htmlFor="financial-year-select"
                        className="sr-only"
                      >
                        Financial Year
                      </label>

                      <select
                        name="fund"
                        id="financial-year-select"
                        className="data-selector"
                        value={selectedYear}
                        onChange={handleYearChange}
                        autoComplete="off"
                      >
                        <option value="">All Year</option>
                        {data &&
                          getDistinctYears(data).map((year) => (
                            <option key={year} value={year}>
                              {year - 1} - {year}
                            </option>
                          ))}
                      </select>
                    </div>

                    {catId === "5" && subcatId === "30" ? (
                      <div className="select-container">
                        <select
                          className="data-selector"
                          value={selectedFileType}
                          onChange={handleFileTypeChange}
                          autoComplete="off"
                        >
                          <option value="">All File Types</option>
                          {data &&
                            getDistinctValuesAsDict(data, "FileEXT").map(
                              ({ FileEXT }) => (
                                <option value={FileEXT}>{FileEXT}</option>
                              ),
                            )}
                        </select>

                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  {catId === "0" ? (
                    <div className="textCenter"></div>
                  ) : (
                    <>
                      {data != [] ? (
                        ""
                      ) : (
                        <div className="errormsgComNew" role="alert">
                          <p>No Data Found</p>
                        </div>
                      )}
                      {currentTableData &&
                        currentTableData.map(
                          ({
                            CategoryID,
                            CategoryName,
                            DocumentDate,
                            DownloadID,
                            FileEXT,
                            FileName,
                            SubCategoryName,
                            Title,
                          }) => (
                            <div className="downlode-box">
                              <div className="">
                                <p className="date">
                                  {DocumentDate != null
                                    ? format(
                                        parseISO(DocumentDate),
                                        "dd-MMM-yyyy",
                                      )
                                    : ""}
                                </p>
                                <p>{Title}</p>
                              </div>
                              <ul>
                                <li>
                                  <a
                                    rel="noreferrer"
                                    href={FileName}
                                    target="blank"
                                    aria-label={`View ${Title} (${DocumentDate ? format(parseISO(DocumentDate), "dd-MMM-yyyy") : ""})`}
                                  >
                                    View
                                  </a>
                                </li>
                                <li>
                                  <button
                                    type="button"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-btn"
                                    data-head={FileName}
                                    onClick={downloadPDF}
                                    aria-label={`Download ${Title}`}
                                  >
                                    Download
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="share-btn"
                                    type="button"
                                    id={`shareButton-${DownloadID}`}
                                    data-id={"s_" + DownloadID}
                                    onClick={handleShareButtonClick}
                                    aria-label={`Share ${Title} document`}
                                  >
                                    <img
                                      src={Download_share}
                                      alt=""
                                      aria-hidden="true"
                                    />
                                  </button>
                                </li>
                                <li>
                                  <div
                                    className="social-icons-download"
                                    id={"d_" + DownloadID}
                                    ref={socialIconsRef}
                                  >
                                    <button
                                      onClick={handleEmailClick}
                                      type="button"
                                      className="icon"
                                      aria-label="Share via email"
                                    >
                                      <i
                                        className="fa fa-envelope"
                                        aria-hidden="true"
                                        data-head={
                                          extractDomainFromURL(
                                            window.location.url,
                                          ) +
                                          "/" +
                                          FileName
                                        }
                                      ></i>
                                    </button>
                                    <div>
                                      <button
                                        onClick={handleCopyClick}
                                        type="button"
                                        className="icon"
                                        aria-label={
                                          isLinkCopied
                                            ? "Link copied"
                                            : "Copy link"
                                        }
                                      >
                                        {isLinkCopied ? (
                                          <span>Copied</span>
                                        ) : (
                                          <i
                                            className="fa fa-link"
                                            aria-hidden="true"
                                            data-head={
                                              extractDomainFromURL(
                                                window.location.url,
                                              ) +
                                              "/" +
                                              FileName
                                            }
                                          ></i>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          ),
                        )}
                      {loadingshow ? (
                        <div
                          className="textcentervertex"
                          role="status"
                          aria-live="polite"
                          aria-busy="true"
                        >
                          <img src={animation} alt="" aria-hidden="true" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        ""
                      )}

                      {currentTableData.length > 0 && (
                        <Pagination
                          align="end"
                          className="pagination-data"
                          current={current}
                          pageSize={size}
                          total={filteredData?.length || 0}
                          onChange={PaginationChange}
                          showSizeChanger={false}
                          showTitle={false}
                          itemRender={itemRender}
                        />
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
}

export default DownloadNew;